export default "__VITE_ASSET__BeZ2K4V6__"